
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";

import useTranslation from "../../Hooks/UseTranslation";

import { exportToPdf } from "../../Services/ProgrammationService";
import { useProject } from "../../Hooks/UseProject";
import { useSelector } from "react-redux";
import axios from "axios";

const FileDownloader = ({ fileUrl, fileName, btnLabel }: any) => {
  const handleDownload = async () => {
    try {
      const response = await axios.get(fileUrl, {
        responseType: "blob", // crucial: tells Axios to treat the response as binary
      });

      const blob = new Blob([response.data]);
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Download failed", error);
    }
  };

  return (
    <button onClick={handleDownload} className="btn btn-normal-2">
      <i className="fas fa-download"></i>{' '}
      {btnLabel}
    </button>
  )
};

interface IPdfExportModalProps {
  show: boolean
  onHide: () => void
  project_id?: string
  plan: string
  navigator?: any
  items: any[]
  nonWorkingDays: string[]
  users: any[]
  filters: any
  columns: any[]
  collapsedGroups: string[]
  collapsedTasks: string[]
}

const PdfExportModal = (props: IPdfExportModalProps) => {


  const {
    show,
    onHide,
    project_id,
    plan,
    items,
    nonWorkingDays,
    users,
    filters,
    columns,
    collapsedGroups,
    collapsedTasks,
    navigator
  } = props

  const { t } = useTranslation();

  const { project } = useProject()

  const { list, tasks, colorCodes } = useSelector((state: any) => state.ProgrammationReducer)

  const [ loading, setLoading ] = useState(true);
  const [ fileUrl, setFileUrl ] = useState('');
  const [ error, setError ] = useState('');

  useEffect(() => {

    const handleExport = async () => {

      setLoading(true);
      setError('');

      try {

        const body = {
          project,
          nonWorkingDays,
          list,
          tasks,
          colorCodes,
          users,
          filters,
          columns,
          collapsedGroups,
          collapsedTasks,
          navigator,
        }

        console.log('body', body)

        const { data: { fileUrl }} = await exportToPdf(plan, body)

        setLoading(false);

        setFileUrl(fileUrl)
      } catch (error) {

        setLoading(false);

        if (error instanceof Error) {

          setError(error.message)
        }
      }

    }

    if (project_id)
      handleExport()
  }, [project_id])

  return (
    <Modal
      show={show}
      centered
      onHide={onHide}
    >
      <Modal.Header>
        <Modal.Title>
          {t('PDF_EXPORT:Title')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
          {loading && (
            <div className="spinner spinner-primary"></div>
          )}
          {!loading && fileUrl && (
            <FileDownloader
              fileUrl={fileUrl}
              fileName={`reporte-${plan}.pdf`}
              btnLabel={t('PDF_EXPORT:DownloadFileLabel')}
            />
          )}
          {error && (
            <div className="alert alert-danger">
              {error}
            </div>
          )}
        </div>
      </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-primary"
            onClick={onHide}
            disabled={loading}
          >
            {t('PDF_EXPORT:CloseButton')}
          </button>
        </Modal.Footer>
    </Modal>
  )
}

export default PdfExportModal;
